import { Component, Input } from '@angular/core'
import { ModalController } from '@ionic/angular'
import { FavouriteSystem } from '../../../models/favourites'
import { Translation } from '../../../services/translation.service'

@Component({
  selector: 'efp-favourites-systems',
  templateUrl: './favourites-systems.page.html',
  styleUrls: ['./favourites-systems.page.scss'],
})
export class FavouritesSystemsPage {
  @Input() favouriteFormworksystems?: FavouriteSystem[]

  constructor(public translate: Translation, private modalCtrl: ModalController) {}

  async selectFavoriteSystem(system: FavouriteSystem): Promise<void> {
    await this.modalCtrl.dismiss({ system })
  }
}
